import React from 'react';

const avaleht = {
	'avaleht.pealkiri': 'Varbla Holiday Village',
	'avaleht.pealkiri2': 'Paradise in hell',
	'avaleht.tutvustus': () => (
		<>
			<p className='is-4'>
				We welcome you to our new home page of Varbla Holiday Village!
			</p>

			<p className='is-4'>
				<strong>
					You have arrived to Pärnu county, place that some like to call{' '}
					<span className='is-3'>PARADISE IN HELL.</span>
				</strong>
			</p>
		</>
	),
	'avaleht.puhkusEestis': () => (
		<>
			<h2 className='title is-2'>Visit Estonia!</h2>

			<p>
				If you are looking for a place in Estonia, where to spend your holiday,
				then our little holiday village would be a perfect place.
			</p>
			<p>
				Motel is located by the Gulf of Riga, which is excellent holiday place
				for families, couples, nature lovers and people who search for a quiet
				place.
			</p>

			<p>
				You can to different activites, such as windsurfing, paddleboarding,
				saunas, volleyball, boatrent and much more.
			</p>
		</>
	),
	'avaleht.puit': () => (
		<>
			<h2 className='title is-2'>Puit</h2>

			<p>
				AS Varbla Puhkekülas tegeldakse ka puitmaterjali tootmise ja
				töötlemisega.
			</p>
			<p>Müüme erinevaid puitmaterjale:</p>
			<ul>
				<li>ehituslik puitmaterjal</li>
				<li>punnlauad</li>
				<li>liistud</li>
				<li>hööveldatud lauad</li>
				<li>
					puidust aiamööbel, sh:
					<ul>
						<li style={{ fontSize: '1em' }}>lillepotid</li>
						<li style={{ fontSize: '1em' }}>kiiged</li>
						<li style={{ fontSize: '1em' }}>prügikasti ümbrised</li>
						<li style={{ fontSize: '1em' }}>katusega istumispingid</li>
						<li style={{ fontSize: '1em' }}>piknikulauad</li>
					</ul>
				</li>
			</ul>
			<p>
				Kui on millegi vastu huvi, siis infot saab helistades numbrile{' '}
				<strong>+372 53586480</strong>
			</p>
		</>
	),
	'majutus.kaart.kirjeldus': () => <></>,
	'toitlustus.kaart.kirjeldus': () => <></>,
	'yritused.kaart.kirjeldus': () => <></>,
	'avaleht.puhkuseIdeed': () => (
		<h2 className='title is-2' style={{ marginBottom: '40px' }}>
			Ways to spend Your time in Varbla Holiday Village:
		</h2>
	),
	'avaleht.koikVajalik': () => (
		<h2 className='title is-2' style={{ marginBottom: '40px' }}>
			We have everything for Your relaxation needs:
		</h2>
	),
};

export default avaleht;
